<template>
  <div class="login-page">
    <header class="navy">
      <nav>
        <div class="logo">
          <a href="#" style="margin-right: 2rem;" @click.prevent="$router.push('/')">
            <img src="@/assets/img/giupnuri_logo.png"/>
          </a>
          <!--Menu-->
<!--          <div class="menu">-->
<!--            <ul>-->
<!--              <li>-->
<!--                <a href="#">-->
<!--                  제품소개-->
<!--                </a>-->
<!--              </li>-->
<!--              <li>-->
<!--                <a href="#">-->
<!--                  고객사례-->
<!--                </a>-->
<!--              </li>-->
<!--              <li>-->
<!--                <a href="#">-->
<!--                  서비스 문의-->
<!--                </a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
        </div>
        <div class="sign">
          <ul>
            <li>
              <a href="#" @click.prevent="$router.push('/account/sign')">
                회원가입
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="$router.push('/account/login')">
                로그인
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!--end::header-->
    <section>
      <article>
        <div class="login_box">
          <div class="login_img">
            <img src="@/assets/img/login.png" alt="">
          </div>
          <div class="login_text">
            <h1>
              로그인
            </h1>
            <div class="login_form">
              <form>
                <div class="id" :class="{fals: $v.params.userID.$error}">
                  <input type="text" name="name" v-model="params.userID">
                  <span>아이디</span>
                  <p class="pw_fals" v-show="$v.params.userID.$error">필수 입력 항목 입니다.</p>
                </div>
                <div class="password" :class="{fals: $v.params.userPWD.$error}" @keyup.enter="doLogin">
                  <input type="password" name="name" v-model="params.userPWD">
                  <span>비밀번호</span>
                  <p class="pw_fals" v-show="$v.params.userPWD.$error">필수 입력 항목 입니다.</p>
                </div>
              </form>
              <div class="btn">
                <button type="button" @click="doLogin">로그인</button>
              </div>
            </div>
            <div class="signup">
              <div class="id_pw">
                <a href="#" @click.prevent="$router.push('/account/findID')">
                  ID/PW 찾기
                </a>
              </div>
              <div>
                <a href="#" @click.prevent="$router.push('/account/sign')">
                  회원가입
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>

    <layout-footer></layout-footer>

  </div>
</template>
<script>
import required from "vuelidate/lib/validators/required";

export default {
  data: function () {
    return {
      params: {
        userID: '',
        userPWD: ''
      }
    }
  },
  validations: {
    params: {
      userID: {
        required
      },
      userPWD: {
        required
      }
    }
  },
  methods: {
    doLogin: function () {
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }

      this.$AccountSvc.login(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log("code: %s, message: %s, entity: %o", code, message, entity)

          if (code === 1) {
            alert('로그인 되었습니다.')
            if (entity.userStatus === 100) {
              if (entity.userType === 1) {
                this.$router.replace({path: '/'})
              } else if (entity.userType === 2) {
                this.$router.replace({path: '/'})
              }
            } else {
              this.$router.replace({path: '/'})
            }
          } else {
            alert(message)
          }
        })
    }
  }
}
</script>
